<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile/aconcagua')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active" :to="localePath('/wine-guide/chile/aconcagua/sena')">
                        Sena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/chile/aconcagua/vina-errazuriz')">Vina Errazuriz
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/chile/aconcagua/vina-von-sibenthal')">Vina Von Sibenthal
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/chile/aconcagua')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Sena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Un'altra delle storie di successo della joint venture cilena; Sena è il frutto di Eduardo Chadwick,
                        proprietario di Viña Errazuriz in Cile, e il compianto, grande, Robert Mondavi. Entrambi visionari
                        produttori di vino, Chadwick e Mondovì sono stati tra i primi a comprendere appieno il potenziale del Cile come a
                        regione vinicola, aprendo la strada a molti altri che ne seguiranno l'esempio.
                    </div>

                    <div class="howto-title2">Elevare la reputazione del Cile</div>
                    <div class="howto-text">
                        Con Bordeaux e Borgogna che dominano gran parte della scena del buon vino alla fine del XX secolo, il
                        l'idea di creare un vino icona cileno sembrava inverosimile. Mentre indubbiamente il terroir del
                        La valle dell'Aconcagua a nord di Santiago era matura per la produzione di qualcosa di molto superiore al
                        plonk economico e allegro per cui il Cile era noto, il savoir faire era scarso sul terreno. accedere
                        Roberto Mondovì. Un amico di lunga data e rispettato collega di Chadwick, insieme hanno deciso
                        per creare Sena, un vino che presto avrebbe cambiato per sempre il volto dell'enologia cilena. Quello era
                        nel 1995. La prima annata è uscita nel 1995 con ottimi punteggi, fino alla metà degli anni '90 in alcuni
                        casi.
                    </div>

                    <div class="howto-title2">Berlino 2004</div>
                    <div class="howto-text">
                        Tuttavia, la vera svolta è arrivata durante la sessione di degustazione alla cieca di Berlino del 2004 (2001
                        Vintage ▾). Sena è arrivata seconda in assoluto (battuta di poco dal suo vino gemello, Viñedo Chadwick
                        2000), battendo i pesi massimi come Châteaux Lafite, Margaux e Latour. La miscela complessa
                        di Cabernet Sauvignon, Carmenère, Merlot, Cabernet Franc e Petit Verdot è stato un successo, e
                        Sena è diventato un nome familiare. Chadwick e Mondovi hanno presentato il vino ancora e ancora in altri
                        degustazioni alla cieca ei risultati sono stati unanimi. Sena era qui per restare. Poco prima della sua morte
                        nel 1997, Robert Mondovi ha venduto la sua quota a Chadwick, permettendogli di assumere il controllo del 100% del
                        impero.
                    </div>

                    <div class="howto-title2">Uno dei vini più costosi del Cile</div>
                    <div class="howto-text">
                        Sena è oggi classificato nella top 10 dei vini più costosi del Cile. Esaltato come alternativa agli onnipresenti Bordeaux e Super Tuscan, il potenziale di invecchiamento di Sena è superbo, ma sorprendentemente è anche uno dei vini iconici più economici sul mercato (prezzi di giugno 2019 di una bottiglia media di € 125 su wine-searcher.com). Le bottiglie dell'ormai mitica annata 2001 sono una rarità e una sorta di superstar nel mondo del buon vino, con una domanda che supera di gran lunga l'offerta.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Sena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Eine weitere Erfolgsgeschichte des chilenischen Joint Ventures; Sena ist die Frucht von Eduardo Chadwick,
                        Besitzer von Viña Errazuriz in Chile und der verstorbene, großartige Robert Mondavi. Beide visionär
                        Die Winzer Chadwick und Mondovi gehörten zu den ersten, die das Potenzial Chiles als Weinbaugebiet voll und ganz erkannten
                        Weinregion, die vielen anderen den Weg bereitet, diesem Beispiel zu folgen.
                    </div>

                    <div class="howto-title2">Chiles Ruf stärken</div>
                    <div class="howto-text">
                        Da Bordeaux und Burgund im späten 20. Jahrhundert einen Großteil der Weinszene dominierten, ist die
                        Die Idee, einen chilenischen Ikonenwein zu kreieren, schien weit hergeholt. Während zweifellos das Terroir der
                        Das Aconcagua-Tal nördlich von Santiago war reif für die Produktion von etwas, das weitaus überlegen war
                        Der billige und fröhliche Trottel, für den Chile bekannt war, das Savoir-faire war dünn gesät. Eingeben
                        Robert Mondovi. Als langjähriger Freund und angesehener Kollege von Chadwick entschieden sie gemeinsam
                        Sena zu kreieren, einen Wein, der bald das Gesicht der chilenischen Weinherstellung für immer verändern würde. Das war
                        im Jahr 1995. Der erste Jahrgang wurde 1995 mit hervorragenden Ergebnissen veröffentlicht, teilweise bis in die Mitte der 90er Jahre
                        Fälle.
                    </div>

                    <div class="howto-title2">Berlin 2004</div>
                    <div class="howto-text">
                        Der eigentliche Wendepunkt kam jedoch während der Berliner Blindverkostung im Jahr 2004 (2001).
                        Jahrgang). Sena belegte insgesamt den zweiten Platz (wobei er knapp von seinem Schwesterwein Viñedo Chadwick geschlagen wurde).
                        2000) und schlug Schwergewichte wie Châteaux Lafite, Margaux und Latour. Die komplexe Mischung
                        aus Cabernet Sauvignon, Carmenère, Merlot, Cabernet Franc und Petit Verdot war ein Erfolg, und
                        Sena wurde ein bekannter Name. Chadwick und Mondovi präsentierten den Wein immer wieder bei anderen
                        Blindverkostungen und die Ergebnisse waren einstimmig. Sena war hier, um zu bleiben. Kurz vor seinem Tod
                        1997 verkaufte Robert Mondovi seinen Anteil an Chadwick, wodurch er die Kontrolle über 100 % des Unternehmens übernehmen konnte
                        Reich.
                    </div>

                    <div class="howto-title2">Einer der teuersten Weine Chiles</div>
                    <div class="howto-text">
                        Sena gehört heute zu den Top 10 der teuersten Weine Chiles. Sena wird als Alternative zu den allgegenwärtigen Bordeaux- und Super-Tuscan-Weinen gepriesen und verfügt über ein hervorragendes Alterungspotenzial, ist aber überraschenderweise auch einer der günstigsten Kultweine auf dem Markt (Preise für durchschnittlich 125 € pro Flasche im Juni 2019 auf wine-searcher.com). Flaschen des mittlerweile legendären Jahrgangs 2001 sind eine Rarität und so etwas wie ein Superstar in der Welt der erlesenen Weine, da die Nachfrage das Angebot bei weitem übersteigt.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Séna</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Une autre des réussites de la coentreprise chilienne; Sena est le fruit d'Eduardo Chadwick,
                        propriétaire de Viña Errazuriz au Chili, et feu, grand, Robert Mondavi. À la fois visionnaire
                        viticulteurs, Chadwick et Mondovi ont été parmi les premiers à comprendre pleinement le potentiel du Chili en tant que
                        région viticole, ouvrant la voie à beaucoup d'autres à emboîter le pas.
                    </div>

                    <div class="howto-title2">Rehausser la réputation du Chili</div>
                    <div class="howto-text">
                        Avec Bordeaux et la Bourgogne dominant une grande partie de la scène des vins fins à la fin du XXe siècle, le
                        l'idée de créer un vin icône chilien semblait farfelue. Si incontestablement le terroir de la
                        La vallée de l'Aconcagua au nord de Santiago était mûre pour la production de quelque chose de bien supérieur à la
                        plonk cheap'n'cheerful pour lequel le Chili était connu, le savoir-faire était mince sur le terrain. Entrer
                        Robert Mondovic. Ami de longue date et collègue respecté de Chadwick, ils ont décidé ensemble
                        pour créer Sena, un vin qui allait bientôt changer à jamais le visage de la vinification chilienne. C'était
                        en 1995. Le premier millésime est sorti en 1995 avec d'excellents scores, jusqu'au milieu des années 90 dans certains
                        cas.
                    </div>

                    <div class="howto-title2">Berlin 2004</div>
                    <div class="howto-text">
                        Cependant, le véritable tournant s'est produit lors de la dégustation à l'aveugle de Berlin en 2004 (2001
                        ancien). Sena est arrivé deuxième au classement général (battu de justesse par son vin jumeau, Viñedo Chadwick
                        2000), battant des poids lourds tels que Châteaux Lafite, Margaux et Latour. Le mélange complexe
                        de Cabernet Sauvignon, Carmenère, Merlot, Cabernet Franc et Petit Verdot a été un succès, et
                        Sena est devenu un nom familier. Chadwick et Mondovi ont présenté le vin encore et encore à d'autres
                        dégustations à l'aveugle et les résultats ont été unanimes. Sena était là pour rester. Peu de temps avant sa mort
                        en 1997, Robert Mondovi a vendu sa part à Chadwick, lui permettant de prendre le contrôle de 100% du
                        Empire.
                    </div>

                    <div class="howto-title2">L'un des vins les plus chers du Chili</div>
                    <div class="howto-text">
                        Sena est aujourd'hui classé dans le top 10 des vins les plus chers du Chili. Présenté comme une alternative aux omniprésents Bordeaux et Super Toscans, le potentiel de garde de Sena est superbe, mais étonnamment, c'est aussi l'un des vins emblématiques les moins chers du marché (prix en juin 2019 d'une moyenne de 125 € la bouteille sur wine-searcher.com). Les bouteilles du désormais mythique millésime 2001 sont une rareté et une sorte de superstar dans le monde des vins fins, avec une demande dépassant de loin l'offre.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Sena</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Another of the Chilean joint venture success stories; Sena is the fruit of Eduardo Chadwick,
                        owner of Viña Errazuriz in Chile, and the late, great, Robert Mondavi. Both visionary
                        winemakers, Chadwick and Mondovi were among the first to fully understand Chile’s potential as a
                        wine region, leading the way for many others to follow suit.
                    </div>

                    <div class="howto-title2">Elevating Chile’s reputation</div>
                    <div class="howto-text">
                        With Bordeaux and Burgundy dominating much of the fine wine scene in the late 20th century, the
                        idea of creating a Chilean icon wine seemed far fetched. While undoubtedly the terroir of the
                        Aconcagua Valley north of Santiago was ripe for production of something far superior than the
                        cheap’n’cheerful plonk that Chile was known for, savoir faire was thin on the ground. Enter
                        Robert Mondovi. A longtime friend and respected colleague of Chadwick’s, together they decided
                        to create Sena, a wine that would soon change the face of Chilean winemaking forever. That was
                        in 1995. The first vintage was released in 1995 to excellent scores, up to the mid-90s in some
                        cases.
                    </div>

                    <div class="howto-title2">Berlin 2004</div>
                    <div class="howto-text">
                        However, the real turning point came during the Berlin blind tasting session of 2004 (2001
                        vintage). Sena came second overall (being narrowly beaten by its sister wine, Viñedo Chadwick
                        2000), beating the heavyweights such as Châteaux Lafite, Margaux and Latour. The complex blend
                        of Cabernet Sauvignon, Carmenère, Merlot, Cabernet Franc and Petit Verdot was a success, and
                        Sena became a household name. Chadwick and Mondovi presented the wine again and again at other
                        blind tastings and the results were unanimous. Sena was here to stay. Shortly before his death
                        in 1997, Robert Mondovi sold his share to Chadwick, allowing him to take control of 100% of the
                        empire.
                    </div>

                    <div class="howto-title2">One of Chile’s most expensive wines</div>
                    <div class="howto-text">
                        Sena is today classed in the top 10 of Chile’s most expensive wines. Extolled as an alternative to the omnipresent Bordeaux and Super Tuscans, Sena’s ageing potential is superb, yet surprisingly is one also of the cheapest iconic wines on the market (June 2019 prices of an average of €125 bottle on wine-searcher.com). Bottles of the now mythical 2001 vintage are a rarity, and something of a superstar in the fine wine world, with demand far outsrtipping supply.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Sena",
    data() {
        return {
            select: {report: 'Sena', src: '/wine-guide/chile/aconcagua/sena'},
            items: [
                {report: 'Sena', src: '/wine-guide/chile/aconcagua/sena'},
                {report: 'Vina Errazuriz', src: '/wine-guide/chile/aconcagua/vina-errazuriz'},
                {report: 'Vina Von Sibenthal', src: '/wine-guide/chile/aconcagua/vina-von-sibenthal'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Sena | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Savor the unique and exceptional flavors of Sena wines, a premium Chilean winery renowned for its expertise in blending traditional winemaking techniques with modern innovations. Producing award-winning red blends, including Cabernet Sauvignon and Merlot, Sena wines are a testament to the rich winemaking heritage of the Maipo Valley. Indulge in the taste of exceptional Chilean wine with every sip of a Sena vintage.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
